var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organism-pins"},_vm._l((_vm.pinsData),function(pin,index){return _c('MoleculePin',{key:index,ref:"pinRef",refInFor:true,attrs:{"pin-data":pin,"expanded":index === _vm.expandedPin,"on-close":_vm.handlePinClose,"on-expand":() => {
        _vm.handlePinExpandWithDeterministicItem(index)
      }}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }